import React, { useEffect } from 'react';
import './Shell.css';
import LinkGenerator from './LinkGenerator';
import { logger } from '../helpers/LoggerHelper';
import { languageHelper } from '../helpers/LanguageHelper';
import { ApplicationContext, ApplicationActionType } from '../context/ApplicationContext';
import {envConfig} from '../configuration/Configuration';
import {ecsHelper} from '../helpers/EcsHelper';
import {Spinner} from '@skype/bew-components/dist/Loading/Spinner'

const Shell: React.FC = () => {

  const { state, dispatch } = React.useContext(ApplicationContext);

  useEffect(() => {
    logger.Log("loaded shell");
    const silentLogin = (window as any).SKYPE.login.Silent;

    let language: string | null = languageHelper.GetCurrentLanguage();
    logger.Log("Language: ", language);

    ecsHelper.loadConfig((settings) => {

      dispatch({ Action: ApplicationActionType.SilentLoginStarted});

      logger.SilentLoginStarted();
      silentLogin.init(envConfig.SilentLogin)
      .setCallback((response: any) => {
          if (response && response.skypetoken) {
              logger.SilentLoginFinishedSuccess();
              dispatch({ Action: ApplicationActionType.SilentLoginFinished, Payload : response.skypetoken});
              return;
          }
          if (response && response.error) {
              logger.SilentLoginFinishedError(response.error);
              dispatch({ Action: ApplicationActionType.SilentLoginFinished, Payload : null});
              return;
          }
      })
      .load();
    });
  },[dispatch]);

  return (
    <div className="meetNowShell">
      {
        state.ApplicationIsBeingPrepared ? <div className="spinnerContainer"><Spinner size={80} /> </div> : 
       <div className="shellItemsContainer">
        <LinkGenerator />
        </div>
        }
    </div>
  );
}

export default Shell;
